import { useTranslation } from 'react-i18next';
import { STATUS_STYLES } from '../../utils/appointmentStatus';

const StatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const s = STATUS_STYLES[status] || STATUS_STYLES.PENDING;
  const label = t(`status.appointment.${status}`, { defaultValue: status?.replace(/_/g, ' ') });

  return (
    <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${s.bg} ${s.text}`}>
      {label}
    </span>
  );
};

export default StatusBadge;
